import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { safetyCourse as t } from './strings'
import * as actions from '../../../actions'
import * as DA from '../../../typeModules/events'
import SafetyCourse from '../../molecules/safety-course'
import ActiveDasherSplash from '../../molecules/safety-course/ActiveDasherSplash'
import ConfirmationSplash from '../../molecules/safety-course/ConfirmationSplash'

type SafetyCourseStepProps = {
  isComplete: boolean
  uniqueLink: string
  completeSafetyCourse?: any
  safetyCourseStep?: {
    isSubmitting: boolean
    isSubmitted: boolean
    error?: null
  }
  courseId: number
  enableCourse: boolean
  getApplicationStatus?: (uniqueLink: string) => any
  trackSafetyCourse?: (
    actions: DA.EventActions,
    name: DA.SafetyCourseSections,
    courseId: number
  ) => Promise<any>
  isActiveRequiredSafetyCourse?: boolean
}
const getButtonState = state => {
  if (state.isSubmitting) {
    return Button.States.Loading
  }
  if (state.isSubmitted) {
    return Button.States.Success
  }
  if (state.error) {
    return Button.States.Error
  }
  return Button.States.Default
}

export const SafetyCourseStep: React.FC<SafetyCourseStepProps> = ({
  uniqueLink,
  completeSafetyCourse,
  safetyCourseStep,
  enableCourse,
  trackSafetyCourse,
  getApplicationStatus,
  courseId,
  isActiveRequiredSafetyCourse,
}) => {
  const [isShowingCourse, setShowingSafetyCourse] = React.useState(false)
  const [hasStartedSafetyCourse, setStartedSafetyCourse] = React.useState(false)
  const [
    isShowingSafetyCourseConfirmation,
    setIsShowingSafetyCourseConfirmation,
  ] = React.useState(false)
  const [slide, setSlide] = React.useState(0)

  if (isShowingSafetyCourseConfirmation) {
    return <ConfirmationSplash />
  }

  if (isShowingCourse) {
    trackSafetyCourse(
      DA.EventActions.Rendered,
      DA.SafetyCourseSections.Course,
      courseId
    )
    return (
      <SafetyCourse
        onClose={currentSlide => {
          setShowingSafetyCourse(false)
          setSlide(currentSlide)
        }}
        track={trackSafetyCourse}
        buttonState={getButtonState(safetyCourseStep)}
        completeCourse={async () => {
          await completeSafetyCourse(uniqueLink)
          if (isActiveRequiredSafetyCourse) {
            return setIsShowingSafetyCourseConfirmation(true)
          }
        }}
        onSubmit={() => {
          return getApplicationStatus(uniqueLink)
        }}
        courseId={courseId}
        currentSlide={slide}
      />
    )
  }

  if (isActiveRequiredSafetyCourse) {
    const today = Date.now()
    const requiredDate = new Date(2021, 7, 1).getTime()
    const remainingDays = Math.floor(
      (requiredDate - today) / (1000 * 60 * 60 * 24)
    )
    return (
      <ActiveDasherSplash
        remainingDays={Math.max(0, remainingDays)}
        onClick={() => setShowingSafetyCourse(true)}
      />
    )
  }

  return (
    <StackChildren>
      <Text>{t.description()}</Text>
      {enableCourse && (
        <Button
          onClick={() => {
            trackSafetyCourse(
              DA.EventActions.Clicked,
              DA.SafetyCourseSections.ConfirmationSection,
              courseId
            )
            setShowingSafetyCourse(true)
            setStartedSafetyCourse(true)
          }}
          type={Button.Types.PrimaryPill}
          isInline
          size={Button.Sizes.Small}
        >
          {hasStartedSafetyCourse ? t.resumeCourseButton() : t.primaryButton()}
        </Button>
      )}
    </StackChildren>
  )
}

const mapStateToProps = state => ({
  safetyCourseStep: state.safetyCourseStep,
})

const mapDispatchToProps = {
  getApplicationStatus: actions.getApplicationStatus,
  trackSafetyCourse: events.trackSafetyCourse,
  completeSafetyCourse: actions.markSafetyCourseComplete,
}
export default connect(mapStateToProps, mapDispatchToProps)(SafetyCourseStep)
